import Swiper, { FreeMode, Navigation, Scrollbar } from 'swiper'

const initNewsSwiper = () => {
  new Swiper('.news-overview__items.swiper', {
    modules: [FreeMode, Scrollbar, Navigation],
    slidesPerView: 'auto',
    spaceBetween: 16,

    freeMode: {
      enabled: true,
      sticky: false,
    },

    scrollbar: {
      el: '.news-overview__scrollbar',
      draggable: true,
      snapOnRelease: false,
    },

    navigation: {
      nextEl: '.news-overview__nav.next',
      prevEl: '.news-overview__nav.prev',
    },

    breakpoints: {
      768: {
        slidesPerView: 'auto',
        spaceBetween: undefined,
        enabled: false,
      },
    },
  })
}

export default initNewsSwiper
